import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    width: 100vw;
    padding-left:10%;
    padding-right:10%;
}
`;

export const Welcome = styled.div`
    font-weight: 400;
    color: #6b6b6b;
    font-size: 3em;
    width: 100vw;
    margin: auto;
    margin-top: 30px;
}
`;

export const MenuContainer = styled.div`
    display: flex;
    height: auto;
    margin-top: 30px;
}
`;

export const Shape = styled.div`
    clip-path: polygon(100% 0, 0 0, 100% 100%);
    background: #1F85FF;
    position: absolute;
    top: 0px;
    right: 0px;
    width: 60vw;
    height: 100vh;
    z-index: -100;
}
`;
